import React from 'react';
import { useGetHomePageInformerData } from 'reactApp/ui/HomePageInformer/hooks/useGetHomePageInformerData';

import { Informer } from '../Informer/Informer';
import styles from './HomePageInformer.css';

export const HomePageInformer = () => {
    const informerData = useGetHomePageInformerData();

    if (!informerData) {
        return null;
    }

    return (
        <Informer
            className={styles.root}
            color={informerData.color}
            closable={informerData.closable}
            onClose={informerData.onClose}
            icon={informerData.icon}
            title={informerData.title}
        >
            <div className={styles.title}>{informerData.message}</div>
        </Informer>
    );
};
